import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const RevoteIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M6.25049 3.49988L6.25049 14.49988C6.25049 18.21315 8.93552 20.99985 12.75049 20.99985" />
      <path d="M19.25 20.4996L19.25 9.49964C19.25 5.78636 16.565 2.99964 12.75 2.99964" />
      <path d="M21.7505 18C21.7505 18 19.9092 20.5001 19.2504 20.5001C18.5916 20.5001 16.7505 18 16.7505 18" />
      <path d="M8.75 5.49998C8.75 5.49998 6.90873 3 6.24998 3C5.59124 3 3.75 5.5 3.75 5.5" />
    </SvgIcon>
  )
}
